import type { AxiosInstance, AxiosResponse } from 'axios';

import type { RootResponse } from '@/models/rootResponse';
import type { Status } from '@/models/status';

class StatusService {
   private provider: AxiosInstance;

   constructor(provider: AxiosInstance) {
      this.provider = provider;
   }

   async getStatuses(): Promise<RootResponse<Status[]>> {
      const response: AxiosResponse<RootResponse<Status[]>> =
         await this.provider.post('/rest/survey-statuses/search');

      return response.data;
   }
}

export default StatusService;
